// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__u0Z23","loading":"skeleton_loading__NOfnf"};